import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    /**
     * Retrieves a preview of the requested {@link ents.core.mosaic.Widget}
     */
    preview: store.actions.request({
      input: store.actions.Data.asIs<{
        /**
         * Always required as this determines where the results are stored in
         * the state
         */
        flexibleIdentifier: ents.core.common.FlexibleIdentifier<ec.models.EntityId>
        query?: ents.core.mosaic.Widget.Query
      }>(),
      output: store.actions.Data.asIs<{
        readonly rawPreview: unknown
      }>(),
      reducers: {
        request: ({ state, data: { flexibleIdentifier } }) => ({
          ...state,
          ...(flexibleIdentifier.id
            ? {
                widgetPreviewLookupById: {
                  ...state.widgetPreviewLookupById,
                  [flexibleIdentifier.id]: { isLoading: true },
                },
              }
            : {}),
          ...(flexibleIdentifier.alias
            ? {
                widgetPreviewLookupByAlias: {
                  ...state.widgetPreviewLookupByAlias,
                  [flexibleIdentifier.alias]: { isLoading: true },
                },
              }
            : {}),
        }),
        error: ({
          state,
          data: {
            error,
            request: { flexibleIdentifier },
          },
        }) => ({
          ...state,
          ...(flexibleIdentifier.id
            ? {
                widgetPreviewLookupById: {
                  ...state.widgetPreviewLookupById,
                  [flexibleIdentifier.id]: { error },
                },
              }
            : {}),
          ...(flexibleIdentifier.alias
            ? {
                widgetPreviewLookupByAlias: {
                  ...state.widgetPreviewLookupByAlias,
                  [flexibleIdentifier.alias]: { error },
                },
              }
            : {}),
        }),
        success: ({
          state,
          data: {
            response: { rawPreview },
            request: { flexibleIdentifier },
          },
        }) => ({
          ...state,
          ...(flexibleIdentifier.id
            ? {
                widgetPreviewLookupById: {
                  ...state.widgetPreviewLookupById,
                  // NOTE: we might as well at least try and see if it works
                  [flexibleIdentifier.id]: {
                    rawPreview,
                    preview: rawPreview as ents.core.mosaic.Widget.Rendering,
                  },
                },
              }
            : {}),
          ...(flexibleIdentifier.alias
            ? {
                widgetPreviewLookupByAlias: {
                  ...state.widgetPreviewLookupByAlias,
                  // NOTE: we might as well at least try and see if it works
                  [flexibleIdentifier.alias]: {
                    rawPreview,
                    preview: rawPreview as ents.core.mosaic.Widget.Rendering,
                  },
                },
              }
            : {}),
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
